import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImgLogoOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45V48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48V45C35.598 45 45 35.598 45 24Z",
		fill: "#EFEFEF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M36.75 19.875C36.75 24.2242 33.2242 27.75 28.875 27.75C24.5258 27.75 21 24.2242 21 19.875C21 15.5258 24.5258 12 28.875 12C33.2242 12 36.75 15.5258 36.75 19.875Z",
		fill: "#EFEFEF"
	})]
});
export default SvgImgLogoOutline;
